import React from 'react';
import './styles.scss';

const LowMealsPrompt = () => {
  return (
    <div className='w-screen py-2 md:py-0 bg-[#FFF5F6] min-h-[63px] flex justify-center items-center prompt -translate-x-4 mb-4 mt-[-24px]'>
      <div className='flex gap-4 justify-center md:justify-start md:gap-12 items-center flex-wrap'>
        <p className='text-red-5'>
          <span className=''> ⚠️ </span>
          You’re running late on certain kitchen items, ensure to have more prepared
        </p>
      </div>
    </div>
  );
};

export default LowMealsPrompt;
